import { createFileRoute } from "@tanstack/react-router";
import { FleetManagementPage } from "@/components/fleet/fleet-management-page";

const FLEET_TABS: ("trucks" | "trailers")[] = ["trucks", "trailers"];

function FleetPage() {
  return <FleetManagementPage initialTab="trucks" tabs={FLEET_TABS} />;
}

export const Route = createFileRoute("/_app/fleet")({
  component: FleetPage,
});
